export default "__VITE_ASSET__CLG1i5MI__"